import React from 'react';
import { Field, FieldProps, FormikErrors } from 'formik';
import getValue from 'lodash/get';
import { FormFieldProps } from '../../types/candidate';

interface BaseFormFieldProps {
    name: string;
    label?: string;
    required?: boolean;
    showLabel?: boolean;
    children: (props: FormFieldProps) => React.ReactNode;
}

export const normalizeError = (
    error: string | FormikErrors<any> | string[] | FormikErrors<any>[] | undefined | false
): string | boolean | undefined => {
    if (!error) return undefined;
    if (typeof error === 'boolean') return error;
    if (typeof error === 'string') return error;

    if (Array.isArray(error)) {
        if (error.length === 0) return undefined;

        const firstError = error[0];
        if (typeof firstError === 'string') return firstError;
        if (typeof firstError === 'object') return 'Invalid value';
        return undefined;
    }

    if (typeof error === 'object') return 'Invalid value';

    return undefined;
};

export const BaseFormField: React.FC<BaseFormFieldProps> = ({
    name,
    showLabel = false,
    label = '',
    required,
    children,
}) => (
    <>
        {showLabel && (
            <label className="fs-14 fw-400 mb-2" htmlFor={name}>
                {label} {required && <span className="lt-text-error">*</span>}
            </label>
        )}
        <Field name={name}>
            {(fieldProps: FieldProps) => {
                const { field, form } = fieldProps;
                const rawError = getValue(form.touched, field.name) && getValue(form.errors, field.name);
                const error = normalizeError(rawError);

                return children({
                    field,
                    form,
                    error,
                    values: form.values,
                    setFieldValue: form.setFieldValue,
                    setFieldTouched: form.setFieldTouched,
                });
            }}
        </Field>
    </>
);
